module.exports = __webpack_public_path__ + "img/collaborate_0.946a31ec.jpg";